import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { AppDispatch, RootState } from "../../../../redux/store";
import {
  fetchDataProviders,
  deleteDataProvider,
} from "../../../../features/auth/store/dataProviderSlice";
import DataProvidersTable from "./DataProvidersTable";
import { CreateDataProviderModal } from "../../Modal/Data/CreateDataProviderModal";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { Button } from "../../../../components/Reusable/Button";
import { DeleteDataProviderModal } from "../../Modal/Data/DeleteDataProvider";
import { EditDataProviderModal } from "../../Modal/Data/EditDataProviderModal";

const DataProviders: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedProvider, setSelectedProvider] = useState<number | null>(null);

  const { dataProviders, loading, error } = useSelector(
    (state: RootState) => state.dataProviders
  );

  useEffect(() => {
    dispatch(fetchDataProviders());
    console.log("✅ useEffect triggered!");
    console.log("📤 About to dispatch fetchDataProviders");
  }, [dispatch]);

  const openDeleteModal = async (id: number) => {
    setSelectedProvider(id);
    setIsDeleteModalOpen(true);
  };

  const openEditModal = async (id: number) => {
    setSelectedProvider(id);
    setIsEditModalOpen(true);
  };

  // const handleDelete = async (id: number) => {
  //   try {
  //     await dispatch(deleteDataProvider(id)).unwrap();
  //     toast.success("Provider deleted!");
  //   } catch (err: any) {
  //     toast.error(err?.message || "Failed to delete provider");
  //   }
  // };

  // Filter and search logic
  const filteredProviders = dataProviders.filter((provider) => {
    const matchesStatus = !statusFilter || provider.status === statusFilter;
    const matchesSearch =
      !searchTerm ||
      provider.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Data Providers">
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4 mb-4">
              <input
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border p-2 rounded w-full"
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="border p-2 rounded w-full"
              >
                <option value="">All Status</option>
                <option value="on">Active</option>
                <option value="off">Inactive</option>
              </select>
            </div>
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
              textColor="text-white"
              borderRadius="rounded-lg"
              className="w-[200px] h-10 ml-6"
            >
              New Provider
            </Button>
          </div>

          <DataProvidersTable
            providers={filteredProviders}
            loading={loading}
            onDelete={openDeleteModal}
            onEdit={openEditModal}
          />
          <CreateDataProviderModal
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
          />
          <EditDataProviderModal
            isOpen={isEditModalOpen}
            id={selectedProvider}
            onClose={() => {
              setIsEditModalOpen(false);
              setSelectedProvider(null);
            }}
          />
          <DeleteDataProviderModal
            id={selectedProvider}
            isOpen={isDeleteModalOpen}
            onClose={() => {
              setIsDeleteModalOpen(false);
              setSelectedProvider(null);
            }}
          />
        </InternalContainer>
        {/* You can add an EditDataProviderModal here, similar to Create */}
      </div>
    </ExternalContainer>
  );
};

export default DataProviders;
